const ALIGN = 'center'

const disabledCols = [
  {
    title: '计划',
    key: 'planName_1',
    type: 'disabled',
    aling: 'left',
    width: 100,
    overflow: true
  },
  {
    title: '素材',
    key: 'imageName_1',
    type: 'disabled',
    aling: 'left',
    overflow: true,
    width: 72
  },
  {
    title: '平台',
    key: 'platform_1',
    type: 'disabled',
    aling: 'left',
    overflow: true,
    width: 84
  },
  {
    title: '应用组',
    key: 'gameGroupName_1',
    width: 80,
    aling: 'left',
    overflow: true,
    type: 'disabled'
  },
  {
    title: '应用',
    type: 'disabled',
    key: 'gameName_1',
    aling: 'left',
    width: 74,
    overflow: true
  },
  {
    title: '项目组',
    type: 'disabled',
    key: 'projectGroupName_1',
    aling: 'left',
    width: 74,
    overflow: true
  },
  {
    title: '人员',
    type: 'disabled',
    key: 'opName_1',
    aling: 'left',
    width: 74,
    overflow: true
  },
  {
    title: '媒体',
    type: 'disabled',
    key: 'mediaName_1',
    aling: 'left',
    width: 74,
    overflow: true
  },
  {
    title: '投放位',
    type: 'disabled',
    key: 'advPositionName_1',
    aling: 'left',
    width: 74,
    overflow: true
  },
  {
    title: '账号',
    type: 'disabled',
    key: 'adAccountName_1',
    aling: 'left',
    width: 140,
    overflow: true
  },
  {
    title: '优化目标',
    type: 'disabled',
    key: 'optimizationTypeName_1',
    aling: 'left',
    width: 90,
    overflow: true
  },
  {
    title: '深度优化目标',
    type: 'disabled',
    key: 'deepOptimizationTypeName_1',
    aling: 'left',
    width: 70,
    overflow: true
  },
  {
    title: '流量来源',
    type: 'disabled',
    key: 'launchSourceName_1',
    aling: 'left',
    width: 90,
    overflow: true
  }
]
export const complexRestCols = [
  {
    title: '账面消耗',
    key: 'paperConsume',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '实际消耗',
    key: 'realConsume',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '新建计划数',
    key: 'newPlanNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '在跑计划数',
    key: 'runPlanNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '无效消耗',
    key: 'invalidConsume',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '无效消耗率',
    key: 'invalidConsumeRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '展示量',
    key: 'pv',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '千次展示成本',
    key: 'profitPvCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '点击量',
    key: 'clickNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '点击成本',
    key: 'clickCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '点击率',
    key: 'clickRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '激活数',
    key: 'activeNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '激活成本',
    key: 'activeCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '注册数',
    key: 'registerNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '注册成本',
    key: 'registerCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '创角账号数',
    key: 'createRoleNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '角色数',
    key: 'newRoleNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '创角账号率',
    key: 'newRoleRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '首日二次付费率',
    key: 'createRolePayTwiceRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '首日等级通过率',
    key: 'roleLevelReachNumRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '变现计划曝光量',
    key: 'adExposureCount',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '计划变现人数',
    key: 'watchFinishUserNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '计划变现次数',
    key: 'watchFinishCount',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '计划变现人均次数',
    key: 'watchFinishAvgCount',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '首日广告变现收入',
    key: 'monetizationAmount24h',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '3日广告变现收入',
    key: 'monetizationAmount3d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '7日广告变现收入',
    key: 'monetizationAmount7d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日广告变现ROI',
    key: 'monetizationRoi24h',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '3日广告变现ROI',
    key: 'monetizationRoi3d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '7日广告变现ROI',
    key: 'monetizationRoi7d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '广告变现人数',
    key: 'adMonetizationUserCount',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '广告变现次数',
    key: 'adMonetizationCount',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '广告变现人均次数',
    key: 'adMonetizationAvgCount',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 90
  },
  {
    title: '创角1小时内等级通过率',
    key: 'roleLevelReachOneHourRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 152
  },
  {
    title: '首日付费创角数',
    key: 'payRole1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角付费次数',
    key: 'newRolePayCnt1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角付费成本',
    key: 'payRoleCost1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日每次付费成本',
    key: 'payRoleEveryCost1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角付费率',
    key: 'payRoleRate1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角充值金额',
    key: 'createRoleMoney1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角ROI',
    key: 'newRoleRoi1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '总流水',
    key: 'totalMoney',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  }
]
export default disabledCols.concat(complexRestCols)
